import { ElioError } from '@elio/shared/models';
import { createAction, props } from '@ngrx/store';

const subscribeToUserTopicSuccess = createAction('[Messaging Subscription Effect] Subscribe to user topic SUCCESS');
const subscribeToUserTopicFailure = createAction(
  '[Messaging Subscription Effect] Subscribe to user topic FAILURE',
  props<{ error: ElioError }>()
);

const subscribeToOfferTopicSuccess = createAction(
  '[Messaging Subscription Effect] Subscribe to current offer topic SUCCESS'
);
const subscribeToOfferTopicFailure = createAction(
  '[Messaging Subscription Effect] Subscribe to current offer topic FAILURE',
  props<{ error: ElioError }>()
);

const unsubscribeToOfferTopicSuccess = createAction(
  '[Messaging Subscription Effect] Unsubscribe to current offer topic SUCCESS'
);
const unsubscribeToOfferTopicFailure = createAction(
  '[Messaging Subscription Effect] Unsubscribe to current offer topic FAILURE'
);

const subscribeToHeadquarterTopicSuccess = createAction(
  '[Messaging Subscription Effect] Subscribe to current headquarter topic SUCCESS'
);
const subscribeToHeadquarterTopicFailure = createAction(
  '[Messaging Subscription Effect] Subscribe to current headquarter topic FAILURE',
  props<{ error: ElioError }>()
);

const unsubscribeToHeadquarterTopicSuccess = createAction(
  '[Messaging Subscription Effect] Unsubscribe to current headquarter topic SUCCESS'
);
const unsubscribeToHeadquarterTopicFailure = createAction(
  '[Messaging Subscription Effect] Unsubscribe to current headquarter topic FAILURE',
  props<{ error: ElioError }>()
);

const successAndLogout = createAction(
  '[Messaging Subscription Effect] Unsubscribe to all topics with SUCCESS and Logout'
);
const failureAndLogout = createAction(
  '[Messaging Subscription Effect] Unsubscribe to all topics with FAILURE and logout'
);

export const MessagingSubscriptionActions = {
  subscribeToUserTopicSuccess,
  subscribeToUserTopicFailure,
  subscribeToOfferTopicSuccess,
  subscribeToOfferTopicFailure,
  unsubscribeToOfferTopicSuccess,
  unsubscribeToOfferTopicFailure,
  successAndLogout,
  failureAndLogout,
  subscribeToHeadquarterTopicSuccess,
  subscribeToHeadquarterTopicFailure,
  unsubscribeToHeadquarterTopicSuccess,
  unsubscribeToHeadquarterTopicFailure,
};
